<template>
    <div class="addTheoryByImport">
        <div class="import-wrap">
            <div class="import-method">
                <p class="label">{{ $t('paper.chooseImportType') }}：</p>

                <el-radio-group v-model="importMethod" size="medium">
                    <el-radio-button label="word"><i class="nucfont inuc-word"></i>{{ $t('paper.wordImport') }}
                    </el-radio-button>
                    <el-radio-button label="excel"><i class="nucfont inuc-excel"></i>{{ $t('paper.excelImport') }}
                    </el-radio-button>
                    <el-radio-button label="write"><i class="nucfont inuc-fuxun"></i>可视化录入
                    </el-radio-button>
                </el-radio-group>
            </div>


            <div class="import-box-file" v-show="importMethod === 'word' || importMethod === 'excel'">
                <img src="../../../assets/images/teacher/paper-import.png" alt="paper-import">
                <div class="import-btn-group">
                    <template v-if="importMethod==='word'">
                        <a :href="wordTemplateURL" class="btn">{{ $t('c.downTemplate', ['Word']) }}</a>
                        <label class="btn" v-if="importMethod==='word'" @change="upload('Word', $event)">
                            {{ $t('paper.wordUpload') }}
                            <input class="file" type="file" accept=".doc,.docx">
                        </label>
                    </template>
                    <template v-if="importMethod==='excel'">
                        <a :href="excelTemplateURL"
                           class="btn">{{ $t('c.downTemplate', ['Excel']) }}</a>
                        <label class="btn" @change="upload('Excel', $event)">
                            {{ $t('paper.excelUpload') }}
                            <input class="file" type="file" accept=".xls,.xlsx">
                        </label>
                    </template>
                </div>
            </div>

            <div class="import-box-write" v-show="importMethod === 'write'">
                <my-topic-add-batch
                    ref="write"
                    class="component-write"
                    :from-paper="true"
                    @on-save="getWriteTopic"
                >
                </my-topic-add-batch>

                <div class="btn-next">
                    <el-button type="primary" @click="generateWriteTopic">生成考题</el-button>
                </div>
            </div>

            <el-alert
                v-if="importLoading"
                title="导入中..."
                type="warning"
                :closable="false"
                center
                show-icon
                style="width: 600px;margin: 50px auto 0;"
            >
            </el-alert>
        </div>
    </div>
</template>

<script>
import MyTopicAddBatch from "@/pages/Topic/MyTopicAddBatch";
import {Ticket} from '@/utils'

export default {
    props: {
        knowledgeName: {},
        forLevel: {},
        difficulty: {},
    },

    components: {
        MyTopicAddBatch
    },

    data() {
        return {
            importMethod: 'word',
            importLoading: false,
            userInfo: Ticket.get()
        }
    },

    computed: {
        wordTemplateURL() {
            return APIURI +
                `api/Download/WordTopicTemplate?culture=${this.$i18n.locale}&ui-culture=${this.$i18n.locale}&access_token=${Ticket.get().access_token}`
        },
        excelTemplateURL() {
            return APIURI +
                `api/Download/ExcelTopicTemplate?culture=${this.$i18n.locale}&ui-culture=${this.$i18n.locale}&access_token=${Ticket.get().access_token}`
        },
    },

    mounted() {
    },

    methods: {
        upload(type, e) {
            let file = e.target.files[0]
            let formData = new FormData()      //创建form对象
            formData.append('file', file)      //通过append向form对象添加数据

            // excel模板中有知识点、适用级别、难易程度
            // word由第一步的数据带过来
            if (type === 'Word') {
                formData.append('knowledgeID', this.knowledgeName[this.knowledgeName.length - 1])
                formData.append('forLevelID', this.forLevel)
                formData.append('difficulty', this.difficulty)
            }

            this.importLoading = true
            this.$api.importTopicPreview(type, formData).then(res => {
                setTimeout(() => {
                    //this.paperData = res.package
                    this.$emit('import-success', res.package)
                    this.importLoading = false
                }, 1000)
            }).catch(() => {
                // 出错时清空文件，不然无法触发change
                e.target.value = ''
                this.importLoading = false
            })
        },

        clearFile() {
            let fileDom = $('.addTheoryByImport .file')[0]
            fileDom.value = ''
        },

        generateWriteTopic() {
            this.$refs.write.generateTopicInPaper()
        },

        getWriteTopic(data) {
            let topics = this.$deepClone(data)

            topics.forEach(item => {
                item.id = 0
                item.creatorID = this.userInfo.userID
                item.knowledge = this.knowledgeName[this.knowledgeName.length - 1]
                item.forLevel = this.forLevel
                item.difficulty = this.difficulty
            })

            this.$emit('import-success', topics)
        }

    },
}
</script>

<style scoped lang="scss">
@import '~@/style/const';

.import-wrap {
    .label {
        margin-right: 5px;
        color: #252525;
        //font-size: 16px;
    }

    .nucfont {
        font-size: 14px;
        margin-right: 5px;
        vertical-align: middle;
    }

    .import-method {
        display: flex;
        align-items: center;
        padding-top: 10px;
    }
}

.import-box-file {
    margin-top: 15vh;
    text-align: center;
}

.import-box-write {
    margin-top: 20px;

    .component-write {
        height: calc(100vh - 240px);
    }

    .btn-next {
        margin-top: 30px;
        text-align: center;
    }
}

.import-btn-group {
    .btn {
        @include button-variant(#fff, $color-theme, $color-theme);
        @include button-size(12px, 25px, 16px, 4px);
        cursor: pointer;

        &:last-child {
            margin-left: 210px;
        }

        > input {
            position: absolute;
            clip: rect(0, 0, 0, 0);
        }
    }
}
</style>
<style lang="scss">
.addTheoryByImport {


}
</style>
